const thumnailList = document.querySelectorAll('.thumbnail-list__item');

document.querySelectorAll('.slide__button').forEach(btn=>{
    btn.addEventListener('click', function(){
        var currentPos = Number(document.querySelector('.thumbnail-list').dataset.position);
        if (this.classList.contains('slide__button--next')) {
            currentPos += 1;
        } else {
            currentPos -= 1;
        }
        thumnailList[currentPos].querySelector('button').click();
    });
});

thumnailList.forEach((thumnail, index)=>{
    const _index = index;
    thumnail.querySelector('button').addEventListener('click', function(){
        document.querySelector('.thumbnail-list').dataset.position = _index;
        document.querySelector('.slide__button--prev').removeAttribute('disabled');
        document.querySelector('.slide__button--next').removeAttribute('disabled');
        if (_index == thumnailList.length - 1) {
            document.querySelector('.slide__button--next').setAttribute('disabled', 'disabled');
        }

        if (_index == 0) {
            document.querySelector('.slide__button--prev').setAttribute('disabled', 'disabled');
        }
    });
});

function delegateSelector(selector, event, childSelector, handler) {

    var is = function(el, selector) {
      return (el.matches || el.matchesSelector || el.msMatchesSelector || el.mozMatchesSelector || el.webkitMatchesSelector || el.oMatchesSelector).call(el, selector);
    };
    
    var elements = document.querySelectorAll(selector);
    [].forEach.call(elements, function(el, i){
        el.addEventListener(event, function(e) {
            if (is(e.target, childSelector)) {
                handler(e);                
            }
        });
    });
}

delegateSelector('body', 'change', '[name="purchaseOption"]', function(event) {
    if( document.querySelector('[name="purchaseOption"]:checked').value == "onetime" ) {
        document.querySelector('.variant-price').classList.remove('subscription-on');
    }
    else {
        document.querySelector('.variant-price').classList.add('subscription-on');
    }
});

